export enum AudioDefine {
    wheelRun = "hall/audios/wheel/wheel_run",
    wheelWin = "hall/audios/wheel/win_little",
    payWheelWin = "hall/audios/wheel/payWheelWin",
    moneyFly = "hall/audios/signinanimation",
}